/* eslint-disable */
import Vue from 'vue'
import store from '@/store/index'
import MainStreamingService from '@/services/MainStreamingService'

class Rooms {
  async indexStreamingRooms () {
    const widget = store.state.widget.data

    if (!widget) {
      return false
    }

    store.state.rooms.list.loading = true

    const data = {
      route: `sessions/organization/${widget.organization.uuid}`,
      params: {}
    }

    return MainStreamingService.get(data)
      .then((response:any) => {
        const res = response ? response.data : null

        if (res && res.statusCode === 0) {
          store.state.rooms.list.data = res.data
        }
      })
      .catch((e) => {
        console.log(e)
      })
      .then(() => {
        store.state.rooms.list.loading = false
      })
  }

  async find (roomId:String) {
    if (!store.state.rooms.item.updating) {
      store.state.rooms.item.loading = true
    }

    const data = {
      route: `sessions/${roomId}/widget`,
      params: {}
    }

    return MainStreamingService.get(data)
      .then((response:any) => {
        const res = response ? response.data : null

        if (res && res.statusCode === 0) {
          store.state.rooms.item.data = res.data
        }
      })
      .catch((e) => {
        console.log(e)
      })
      .then(() => {
        store.state.rooms.item.loading = false
        store.state.rooms.item.updating = false
      })
  }
}

Vue.prototype.$rooms = new Rooms()
